module.exports = __webpack_public_path__ + "img/graduation-hat.36e0eeb5.png";